import { Alert, Snackbar, Typography } from '@mui/material';
import ChoiceScreen from './Pages/Login/ChoiceScreen';
import CommunityLandingPage from './Pages/Landing/CommunityLandingPage';
import ContactPage from './Pages/Landing/ContactPage';
import FeaturesPage from './Pages/Landing/FeaturesPage';
import PrivacyPolicyPage from './views/pages/saas-pages/PrivacyPolicy';
import TermsAndConditionsPage from './views/pages/saas-pages/TermsAndConditions';
import axiosInstance from 'Services/APIService';
import CarporateServices from 'components/NDIS_section/ndisOperations/carporateServices/CarporateServices';
import ClientIncidentForm from 'components/NDIS_section/reportAllForms/forms/ClientIncidentForm';
import DataBreachIncidentForm from 'components/NDIS_section/reportAllForms/forms/DataBreachIncidentForm';
import EmployeeIncidentReportForm from 'components/NDIS_section/reportAllForms/forms/EmployeeIncidentForm';
import EquipmentIncidentReportForm from 'components/NDIS_section/reportAllForms/forms/EquipmentIncidentReportForm';
import FeedbackComplaintsForm from 'components/NDIS_section/reportAllForms/forms/FeedbackComplaintsForm';
import MaintenanceForm from 'components/NDIS_section/reportAllForms/forms/MaintenanceRequestForm';
import MedicationIncidentReportForm from 'components/NDIS_section/reportAllForms/forms/MedicationIncidentReportForm';
import OutreachForm from 'components/NDIS_section/reportAllForms/forms/OutreachForm';
import RestrictivePracticesReportForm from 'components/NDIS_section/reportAllForms/forms/RestrictivePracticesReportForm';
import UnauthorizedPage from 'components/app/UnauthorizedPage';
import ProfileContent from 'components/app/profileSettings/ProfileContent';
import ProfileSettings from 'components/app/profileSettings/ProfileSettings';
import ServicesContent from 'components/app/profileSettings/ServicesContent';
import UsersSocialProfile from 'components/app/usersSocialProfile/UsersSocialProfile';
import IncomeExpensesList from 'components/incomeExpenses/IncomeExpensesList';
import PayroleLandingPage from 'components/payrol/PayroleLandingPage';
import { TabProvider } from 'components/payrol/TabContext';
import DocumentManagement from 'components/payrol/documentManagement/DocumentManagement';
import { DocumentManagementProvider } from 'components/payrol/documentManagement/DocumentManagementContext';
import PeoplePage from 'components/payrol/peoples/PeoplePage';
import ManageRoles from 'components/platformAdmin/ManageRoles';
import { FC, useEffect, useState } from 'react';
import { Navigate, Outlet, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ECommerceServices from './Pages/AppPages/ECommerceServices';
import ProjectDetail from './Pages/CommunityOnBoarding/ProjectDetail';
import ProjectManagement from './Pages/CommunityOnBoarding/ProjectManagement';
import LoarAgreementForm from './Pages/InvestmentLending_BorrowerPages/LoanAgreement_Components/Forms/LoanAgreement';
import HumanResourcesManagement from './Pages/InvestmentLending_BorrowerPages/index';
import InvLending_Management from './Pages/InvestmentLending_Management/index';
import LoginRedirect from './Pages/Login/LoginRedirect';
import MembershipManagement from './Pages/MembershipManagement';
import ProgressnotesMain from './Pages/NdisBussnessTools';
import ShiftNotes from './Pages/NdisBussnessTools/components/Shift_Notes';
import Scenario from './Pages/Scenario/Scenario';
import UserManagement from './Pages/UserManagement/UserManagement';
import { useAppSelector } from './app/hooks';
import CustomBreadcrumb from './commonComponents/CustomBreadcrumb';
import ListOfManagers from './components/NDIS_section/ListOfManagers';
import OfficeSupport from './components/NDIS_section/OfficeSupport';
import ProfileMainPage from './components/NDIS_section/ProfileMainPage';
import SupportWorkersList from './components/NDIS_section/SupportWorkersList';
import UserProfile from './components/NDIS_section/UserProfile';
import WorkersList from './components/NDIS_section/WorkersList';
import CalenderEvents from './components/NDIS_section/calendarEvents/CalenderEvents';
import ClockInOut from './components/NDIS_section/clockInOut/ClockInOut';
import MessagesPlatform from './components/NDIS_section/messagesPlatform/MessagesPlatformMain';
import NdisOperations from './components/NDIS_section/ndisOperations/NdisOperations';
import FinanceTab from './components/NDIS_section/ndisOperations/finance/FinanceTab';
import ReportAll from './components/NDIS_section/reportAllForms/ReportAll';
import RequestShifts from './components/NDIS_section/shiftDetails/RequestShifts';
import ShiftDetailsTable from './components/NDIS_section/shiftDetails/ShiftDetailsTable';
import ShiftsCalendarView from './components/NDIS_section/shiftDetails/ShiftsCalenderView';
import { AuthenticatedRoute } from './components/app-registration/authenticated-route';
import ProductDetails from './components/layout/ProductPage';
import MemberReviewForm from './components/membershipManagement/MemberReviewForm';
import GroupsCard from './components/platformAdmin/GroupsCard';
import ServicesCard from './components/platformAdmin/ManageServices';
import MembersCard from './components/platformAdmin/MembersCard';
import ContactSubmissionsTab from './components/platformAdmin/ContactSubmissionsTab';
import PlatformTabs from './components/platformAdmin/PlatformTabs';
import ThemeCustomization from './themes';
import KanbanPage from './views/application/kanban';
import Backlogs from './views/application/kanban/Backlogs';
import Board from './views/application/kanban/Board';
import Profile1 from './views/application/users/account-profile/Profile1';
import UserCardView from './views/application/users/card/CardStyle1';
import UserListView from './views/application/users/list/Style1';

// Import the DrawerProvider
import { Box } from '@mui/system';
import AssestsPurchase from 'components/fundManagement/AssetsPurchase/AssetsPurchase';
import FundManagementConfigurationPanel from 'components/fundManagement/FundManagementConfigurationPanel';
import FundManagementInvestment from 'components/fundManagement/FundManagementInvestment';
import UnitPurchase from 'components/fundManagement/UnitPurchase/UnitPurchase';
import AssetsList from 'components/fundManagement/assetList/AssetsList';
import FundRequest from 'components/fundManagement/fundRequest/ApprovalRequest';
import ExpenseLedger from 'components/fundManagement/reports/ExpenseLedger';
import FundManagementReports from 'components/fundManagement/reports/FundManagementReports';
import GroupReport from 'components/fundManagement/reports/GroupReport';
import InvestorLedger from 'components/fundManagement/reports/InvestorLedger';
import SellUnits from 'components/fundManagement/sellUnits/SellUnits';
import SimulationDashboard from 'components/fundManagement/simulationDashboard/SimulationDashboard';
import { useDrawer } from './components/app/DrawerContext';
import SellAssets from 'components/fundManagement/sellAssets/SellAssets';
import MainDashboard from 'components/fundManagement/mainDashboard/MainDashboard';
import CertificateList from 'components/fundManagement/reports/CertificateList';

// Component to protect routes for unauthenticated users
const UnauthenticatedRoute: FC<{ children: React.ReactNode }> = ({ children }) => {
  const userDetails = localStorage.getItem('user-details');
  const isAuthenticated = !!(userDetails && JSON.parse(userDetails)?.token);

  if (isAuthenticated) {
    return <Navigate to="/services" replace />;
  }
  return <>{children}</>;
};

// Main Layout Component with Breadcrumb
const MainLayout: FC = () => {
  const { getContentMarginLeft, isMobile } = useDrawer();

  return (
    <div className="main-layout">
      {/* Breadcrumb Navigation - Now positioned correctly */}
      <Box
        className="breadcrumb-container"
        sx={{
          position: 'fixed',
          top: { xs: '60px', sm: '70px' }, // 60px for mobile, 70px for larger screens
          left: isMobile ? 0 : getContentMarginLeft(),
          right: 0,
          padding: '0 16px',
          backgroundColor: '#fafafa',
          borderBottom: '1px solid #e0e0e0',
          zIndex: 1298,
          transition: 'left 0.3s ease'
        }}
      >
        <CustomBreadcrumb showHomeIcon={true} maxItems={6} />
      </Box>

      {/* Main Content Area - Adjusted for breadcrumb */}
      <div
        className="main-content"
        style={{
          minHeight: 'calc(100vh - 120px)', // Account for header + breadcrumb
          marginTop: '50px' // Space for breadcrumb
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};



// Component to protect routes requiring group and service selection
const GroupAndServiceProtectedRoute: FC = () => {
  const navigate = useNavigate();
  const location = useLocation(); // ADD THIS LINE
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  // Check for both group and service immediately
  const selectedProject = localStorage.getItem('selectedProject');
  const servicesState = localStorage.getItem('servicesState');
  const hasRequiredSelections = !!(selectedProject && servicesState);

  useEffect(() => {
    // ONLY redirect if missing requirements AND not already on /services
    if (!hasRequiredSelections && location.pathname !== '/services') {
      setOpenSnackbar(true);
      setIsChecking(false);
      navigate('/services', { replace: true });
      return;
    }

    setIsChecking(false);
  }, [hasRequiredSelections, navigate, location.pathname]); // ADD location.pathname

  // Listen for localStorage changes (in case user clears storage)
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'selectedProject' || e.key === 'servicesState') {
        const updatedProject = localStorage.getItem('selectedProject');
        const updatedServices = localStorage.getItem('servicesState');

        // ONLY redirect if missing requirements AND not already on /services
        if ((!updatedProject || !updatedServices) && location.pathname !== '/services') {
          navigate('/services', { replace: true });
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [navigate, location.pathname]); // ADD location.pathname

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  // Show loading state while checking
  if (isChecking) {
    return <div>Loading...</div>; // Or your loading component
  }

  // Block access if requirements not met
  if (!hasRequiredSelections) {
    return (
      <>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            severity="error"
            sx={{
              backgroundColor: '#fff2f0',
              border: '1px solid #ffccc7',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              padding: '16px',
              maxWidth: '300px',
              '& .MuiAlert-icon': {
                color: '#ff4d4f',
                fontSize: '24px',
                marginRight: '8px'
              },
              '& .MuiAlert-message': {
                padding: 0
              }
            }}
          >
            <div style={{ lineHeight: '1.5' }}>
              <Typography sx={{ fontWeight: 500, margin: 0 }}>Access Denied</Typography>
              <Typography sx={{ margin: '8px 0 0', fontSize: '0.9rem', color: '#666' }}>
                Group and service selection required. Redirecting...
              </Typography>
            </div>
          </Alert>
        </Snackbar>
        {/* Don't render outlet, just redirect */}
        <Navigate to="/services" replace />
      </>
    );
  }

  // Only render MainLayout with breadcrumb if requirements are met
  return <MainLayout />;
};


function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const { messages } = useAppSelector((state) => state.appData);
  const [authorizedRoutes, setAuthorizedRoutes] = useState<string[]>([]);

  // // Fetch authorized routes from API
  // useEffect(() => {
  //   const fetchAuthorizedRoutes = async () => {
  //     const userDetails = localStorage.getItem('user-details');
  //     if (userDetails) {
  //       try {
  //         const { email } = JSON.parse(userDetails);
  //         if (email) {
  //           const response = await axiosInstance.get(
  //             `/auth/get-user-routes?email=${encodeURIComponent(email)}`
  //           );
  //           setAuthorizedRoutes(response.data);
  //         }
  //       } catch (error) {
  //         console.error('Error fetching authorized routes:', error);
  //         setAuthorizedRoutes([]);
  //       }
  //     }
  //   };

  //   fetchAuthorizedRoutes();
  // }, []);

    useEffect(() => {
    let isMounted = true;

    const fetchAuthorizedRoutes = async () => {
      try {
        const userDetails = localStorage.getItem('user-details');
        if (!userDetails) {
          if (isMounted) setAuthorizedRoutes([]);
          return;
        }

        const { email } = JSON.parse(userDetails);
        if (!email) {
          if (isMounted) setAuthorizedRoutes([]);
          return;
        }

        const response = await axiosInstance.get(
          `/auth/get-user-routes?email=${encodeURIComponent(email)}`,
          { timeout: 1000000 }
        );

        if (isMounted) {
          setAuthorizedRoutes(Array.isArray(response.data) ? response.data : []);
        }
      } catch (error: any) {
        console.error('Error fetching authorized routes:', {
          message: error?.message,
          code: error?.code,
          status: error?.response?.status,
          data: error?.response?.data,
          url: error?.config?.url
        });

        if (isMounted) {
          setAuthorizedRoutes([]);
        }
      }
    };

    fetchAuthorizedRoutes();

    return () => {
      isMounted = false;
    };
  }, []);



  return (
    <ThemeCustomization>
      {/* <DrawerProvider> */} {/* Wrap your app with DrawerProvider */}
      <Routes>
        {/* Public routes - No breadcrumb needed */}
        <Route
          path="/"
          element={
            <UnauthenticatedRoute>
              <CommunityLandingPage />
            </UnauthenticatedRoute>
          }
        />
        <Route
          path="/features"
          element={
            <UnauthenticatedRoute>
              <FeaturesPage />
            </UnauthenticatedRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <UnauthenticatedRoute>
              <ContactPage />
            </UnauthenticatedRoute>
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        <Route
          path="/login"
          element={
            <UnauthenticatedRoute>
              <ChoiceScreen />
            </UnauthenticatedRoute>
          }
        />
        <Route path="/redirect" element={<LoginRedirect />} />

        {/* Protected routes requiring authentication */}
        <Route element={<AuthenticatedRoute />}>
          {/* Services route - No breadcrumb needed (it's the entry point) */}
          <Route path="/services" element={<Scenario />} />
          <Route path="/unAuthorised" element={<UnauthorizedPage />} />

          {/* Routes requiring group and service selection - WITH Breadcrumb */}
          <Route element={<GroupAndServiceProtectedRoute />}>
            {/* Platform Admin Routes */}
            <Route path="platform-admin" element={<PlatformTabs />}>
              <Route index element={<Navigate to="groups" replace />} />
              <Route path="groups" element={<GroupsCard />} />
              <Route path="services" element={<ServicesCard />} />
              <Route path="members" element={<MembersCard />} />
              <Route path="roles" element={<ManageRoles />} />
              <Route path="contact-submissions" element={<ContactSubmissionsTab />} />
            </Route>

            {/* Profile Settings Routes */}
            <Route path="profile-settings" element={<ProfileSettings />}>
              <Route index element={<ProfileContent />} />
              <Route path="services" element={<ServicesContent />} />
            </Route>

            {/* Social Profile */}
            <Route path="Users-SocialProfile" element={<UsersSocialProfile />} />

            {/* Community Onboarding */}
            <Route path="OnboardingCommunities" element={<ProjectManagement />} />

            {/* Main Profile Routes */}
            <Route path="profile" element={<ProfileMainPage />}>
              <Route path="user-info" element={<UserProfile />} />
              <Route path="managers" element={<ListOfManagers />} />
              <Route path="workers" element={<WorkersList />} />
              <Route path="support-workers" element={<SupportWorkersList />} />
              <Route path="weekly-patients-schedule" element={<CalenderEvents />} />
              <Route path="ShiftNotes" element={<ShiftNotes />} />
              <Route path="office-support" element={<OfficeSupport />} />
            </Route>

            {/* Task Board Routes */}
            <Route path="taskboard" element={<KanbanPage />}>
              <Route path="board" element={<Board />} />
              <Route path="Backlogs" element={<Backlogs />} />
            </Route>

            {/* Report Forms Routes */}
            <Route path="profile/report-all" element={<ReportAll />} />
            <Route path="feedback-complaints" element={<FeedbackComplaintsForm />} />
            <Route path="maintenance" element={<MaintenanceForm />} />
            <Route path="outreach" element={<OutreachForm />} />
            <Route path="Client-Incident" element={<ClientIncidentForm />} />
            <Route path="dataBreach-Incident" element={<DataBreachIncidentForm />} />
            <Route path="employee-IncidentReport" element={<EmployeeIncidentReportForm />} />
            <Route path="equipment-IncidentReport" element={<EquipmentIncidentReportForm />} />
            <Route path="medication-IncidentReport" element={<MedicationIncidentReportForm />} />
            <Route
              path="restrictive-PracticesReport"
              element={<RestrictivePracticesReportForm />}
            />

            {/* Payroll Routes */}
            <Route
              path="payroll/*"
              element={
                <TabProvider>
                  <PayroleLandingPage />
                </TabProvider>
              }
            >
              <Route path="people" element={<PeoplePage />} />
              <Route
                path="documents/*"
                element={
                  <DocumentManagementProvider>
                    <Typography variant="h5">
                      <DocumentManagement />
                    </Typography>
                  </DocumentManagementProvider>
                }
              />
              <Route
                path="onboarding"
                element={<Typography variant="h5">Onboarding Section</Typography>}
              />
              <Route index element={<PeoplePage />} />
            </Route>

            {/* Fund Management Investment Routes - Nested Structure */}
            <Route path="fundManagementInvestment" element={<FundManagementInvestment />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<MainDashboard />} />
              <Route path="purchase-units" element={<UnitPurchase />} />
              <Route path="sell-units" element={<SellUnits />} />
              <Route path="purchase-assets" element={<AssestsPurchase />} />
              <Route path="request" element={<FundRequest />} />
              <Route path="all-assets" element={<AssetsList />} />
              <Route path="simulation" element={<SimulationDashboard />} />
              <Route path="configuration" element={<FundManagementConfigurationPanel />} />
              <Route path="sell-assets" element={<SellAssets />} />

              {/* Reports Routes */}
              <Route path="reports" element={<FundManagementReports />} />
              <Route path="group-report" element={<GroupReport />} />
              <Route path="reports/expense-ledger" element={<ExpenseLedger />} />
              <Route path="reports/investor-ledger" element={<InvestorLedger />} />
              <Route
                path="reports/certificates"
                element={<CertificateList />}
              />
              
            </Route>

            {/* Financial Routes */}
            <Route path="income-expenses" element={<IncomeExpensesList />} />

            {/* Shift Management Routes */}
            <Route path="Shifts-Details" element={<ShiftDetailsTable />} />
            <Route path="requested-shifts" element={<RequestShifts />} />
            <Route path="clockInOut" element={<ClockInOut />} />
            <Route path="CalenderShifts" element={<ShiftsCalendarView />} />

            {/* NDIS Operations Routes */}
            <Route path="ndis-operations" element={<NdisOperations />} />
            <Route
              path="ndis-operations/people-culture"
              element={<Typography>People & Culture Content</Typography>}
            />
            <Route path="ndis-operations/corporate-services" element={<CarporateServices />} />
            <Route
              path="ndis-operations/information-technology"
              element={<Typography>IT Content</Typography>}
            />
            <Route path="ndis-operations/finance" element={<FinanceTab />} />
            <Route
              path="ndis-operations/risk-compliance-governance"
              element={<Typography>Risk & Compliance Content</Typography>}
            />
            <Route
              path="ndis-operations/marketing-engagement"
              element={<Typography>Marketing Content</Typography>}
            />

            {/* Messages and Communication */}
            <Route path="profile/Messages" element={<MessagesPlatform />} />

            {/* Management Routes */}
            <Route path="membership-management" element={<MemberReviewForm />} />
            <Route path="staff-progress-notes" element={<ProgressnotesMain />} />
            <Route path="humanresources-management" element={<HumanResourcesManagement />} />
            <Route path="usermanagement" element={<UserManagement />} />

            {/* Project Management Routes */}
            <Route path="projectmanagement" element={<ProjectManagement />} />
            <Route path="projectmanagement/:id" element={<ProjectDetail />} />

            {/* User Management Routes */}
            <Route path="membership-applications-list" element={<UserListView />} />
            <Route path="active-user-cards" element={<UserCardView />} />
            <Route path="user-profile-test" element={<Profile1 example_attr={''} />} />
            <Route path="memebership-applications" element={<MembershipManagement />} />

            {/* Investment & Lending Routes */}
            <Route path="InvestmentLending-management" element={<HumanResourcesManagement />} />
            <Route path="InvestmentLending-management-Lender" element={<InvLending_Management />} />
            <Route path="investment-loan-application" element={<LoarAgreementForm />} />

            {/* Business Tools Routes */}
            <Route path="ndis-business-tools" element={<ProgressnotesMain />} />
            <Route path="Community-Services" element={<ProgressnotesMain />} />

            {/* E-commerce Routes */}
            <Route path="ecommerce-services" element={<ECommerceServices />} />
            <Route path="details/:name" element={<ProductDetails />} />

            {/* Studies Route */}
            <Route path="studies" element={<Scenario />} />
          </Route>
        </Route>
      </Routes>
      {/* </DrawerProvider> */}
    </ThemeCustomization>
  );
}

export default App;